module.exports = __webpack_public_path__ + "static/media/zocaloSanitarioMediaCaña.d4bff609.jpg";